<template>
  <!-- 自定义字段在列表中的显示 -->
  <div class="custom-column">
    <div v-if="columnType === 'image'">
      <image-show v-model="columnValue" width="1rem" height="1rem"/>
    </div>
    <div v-else>{{columnValue}}</div>
  </div>
</template>

<script>

import {watch} from "vue";
import imageUtil from "@/util/imageUtil";
import ImageShow from "@/components/h5/image/ImageShow.vue";

export default {
  props: {
    data: { // table中的数据行
      type: Object,
      default: () => {}
    },
    setting: { // 自定义字段配置
      type: Array,
      default: () => []
    },
    propColumn: { // 要显示的字段名称
      type: String,
      default: ''
    }
  },
  name: "",
  components: {
    ImageShow
  },
  data() {
    return {
      columnCode: "", // 取哪个字段
      columnValue: "", // 字段值
      columnValueMulti: [], // 多选框值
      columnType: "", // 字段类型
      optionList: [], // 选项列表
    };
  },
  created() {
    if (!this.propColumn) {
      return;
    }
    this.init();
    watch(() => this.data, () => this.init());
    watch(() => this.setting, () => this.init());
  },
  methods: {
    init() {
      this.columnCode = this.propColumn.split(".")[1]; // 哪个字段
      this.columnValue = this.data.customerForm?this.data.customerForm[this.columnCode]: ""; // 字段的值
      for (let i = 0; i < this.setting.length; i++) { // 字段类型
        if (this.setting[i].columnName === this.columnCode) {
          this.columnType = this.setting[i].columnTypeDisplay;
          if (this.columnType === "select") { // select，从option中获取中文
            this.optionList = JSON.parse(this.setting[i].columnSetting || "[]");
            this.columnValue = this.getValueFromList(this.optionList, this.columnValue);
          } else if (this.columnType === "selectMulti" && this.columnValue) { // selectMulti，从option中获取中文
            this.optionList = JSON.parse(this.setting[i].columnSetting || "[]");
            this.columnValueMulti = this.columnValue.split(",");
            this.columnValue = this.getMultiValue(this.optionList, this.columnValueMulti);
          } else if (this.columnType === "image") { // text，直接显示
            this.columnValue = imageUtil.getFileUrlSingle(this.columnValue);
          } else if (this.columnType === "date") {
            this.columnValue = this.columnValue? this.columnValue.slice(0, 10): "";
          }
          break;
        }
      }
    },
    getValueFromList(list, val) {
      let item = list.find(item => item.code === val);
      return item ? item.value : "";
    },
    // 多选框，将array转成string
    getMultiValue(list, valArr) {
      let arr = [];
      valArr.forEach(i => {
        arr.push(this.getValueFromList(list, i))
      })
      return arr.join("、")
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-column{
  .selected-options{
    &:after{
      content: "、";
    }
    &:last-child{
      content: ""
    }
  }
}
</style>